// @flow

import * as React from 'react';

type Props = {
  toggleMultiSort: () => void,
  multiColumnSort: boolean
};

const MultiSortAction = (props: Props) => {
  const { multiColumnSort, toggleMultiSort } = props;
  return (
    <div style={{ fontSize: 13, display: 'flex', paddingTop: 3 }}>
      <input
        style={{ marginRight: 5, marginTop: 0 }}
        type='checkbox'
        checked={multiColumnSort}
        onChange={toggleMultiSort}
      />
      Multi-Column Sort
    </div>
  );
}

export default MultiSortAction;
